namespace TabAurous.ProductDevelopment {
    export namespace PDQuotationItemsService {
        export const baseUrl = 'ProductDevelopment/QuotationItems';

        export declare function Create(request: Serenity.SaveRequest<PDQuotationItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PDQuotationItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PDQuotationItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PDQuotationItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CustomList(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<PDQuotationItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function QuotationCreatedBySpecSheet(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<PDQuotationItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "ProductDevelopment/QuotationItems/Create",
            Update = "ProductDevelopment/QuotationItems/Update",
            Delete = "ProductDevelopment/QuotationItems/Delete",
            Retrieve = "ProductDevelopment/QuotationItems/Retrieve",
            List = "ProductDevelopment/QuotationItems/List",
            CustomList = "ProductDevelopment/QuotationItems/CustomList",
            QuotationCreatedBySpecSheet = "ProductDevelopment/QuotationItems/QuotationCreatedBySpecSheet"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'CustomList', 
            'QuotationCreatedBySpecSheet'
        ].forEach(x => {
            (<any>PDQuotationItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
